import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

//-- react-router configuration --//
import { BrowserRouter } from "react-router-dom";
//-- --//

//-- redux and redux-thunk configuration --//
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import sidebarCategoryReducer from "./store/reducer/sidebarCategory";
import carouselDataReducer from "./store/reducer/carouselData";
import homeProductsReducer from "./store/reducer/homeProducts";
import bannerReducer from "./store/reducer/banner";
import categoryProductsReducer from "./store/reducer/categoryProducts";
import workoutPlans from "./store/reducer/workouts";
import collection from "./store/reducer/collection";
import myAccountReducer from "./store/reducer/account";
import StockManagementReducer from "./store/reducer/stock";

//Admin
import addCategoryReducer from "./store/reducer/addCategory";
import addSubCategoryReducer from "./store/reducer/addSubCategory";
import categoriesReducer from "./store/reducer/categories";
import brandsReducer from "./store/reducer/brands";
import attributeReducer from "./store/reducer/attributes";
import galleryReducer from "./store/reducer/gallery";
import generalReducer from "./store/reducer/general";
import productReducer from "./store/reducer/products";
import authReducer from "./store/reducer/auth";
import couponsReducer from "./store/reducer/coupons";
import cartReducer from "./store/reducer/cart";
import addressReducer from "./store/reducer/address";
import staffReducer from "./store/reducer/addStaff";
import bookingReducer from "./store/reducer/myBookings";
import reviewReducer from "./store/reducer/review";
import fetchOrdersReducer from "./store/reducer/orders";
import shopReducer from "./store/reducer/shop";
import clientReducer from "./store/reducer/clients";

// -- -- //
const rootReducer = combineReducers({
  sidebarCategory: sidebarCategoryReducer,
  carouselData: carouselDataReducer,
  homeProducts: homeProductsReducer,
  banner: bannerReducer,
  client:clientReducer,
  categoryProducts: categoryProductsReducer,
  workouts: workoutPlans,
  collection: collection,
  addCategory: addCategoryReducer,
  addSubCategory: addSubCategoryReducer,
  category: categoriesReducer,
  brands: brandsReducer,
  attributes: attributeReducer,
  gallery: galleryReducer,
  general: generalReducer,
  products: productReducer,
  auth: authReducer,
  coupons: couponsReducer,
  cart: cartReducer,
  address: addressReducer,
  staffs: staffReducer,
  bookings: bookingReducer,
  review: reviewReducer,
  orders: fetchOrdersReducer,
  shop: shopReducer,
  account:myAccountReducer,
  stock:StockManagementReducer
});

//-- redux store creation --//
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
//   trace: true,
//   traceLimit: 25
// }) || compose;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
//-- --//

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
